import React from 'react';

import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import styled, { ThemeProvider } from 'styled-components';

import Trending from 'components/features/components/trending-section';
import HeroHeading from 'components/hero-heading';
import { useTrendingData } from 'hooks/use-trending-data';
import { theme } from 'styles/configure-theme';

const StyledHeroHeading = styled(HeroHeading)`
  padding: 3.5rem 0 1rem;
  font-size: 2.1rem;
  font-weight: normal;
  line-height: 0.61;
  text-transform: uppercase;

  ${Styles.desktop`
    text-align: center;
    padding: 5rem 0 0;
    font-size: 4rem;
  `}
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 48px;
`;

interface ITrendingPage {
  className: string;
  header: boolean;
}

const TrendingPage: React.FC<ITrendingPage> = ({ className }) => {
  const { formatMessage } = useIntl();

  const { data, loading } = useTrendingData();

  return (
    <ThemeProvider theme={theme}>
      <Wrapper className={className}>
        <Helmet title={formatMessage({ id: 'trending' })} />
        <StyledHeroHeading>{formatMessage({ id: 'trending' })}</StyledHeroHeading>
        {data && <Trending item={data} loading={loading} header={false} />}
      </Wrapper>
    </ThemeProvider>
  );
};

export default TrendingPage;
